import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon4k: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-Icon4k"><Path d="M9.38281 13.0684H7.13184V13.0293L9.34863 9.51855H9.38281V13.0684Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM9.35352 14.2061V15.5H10.7549V14.2061H11.6826V13.0293H10.7549V8.4541H8.6748L5.84766 12.9756V14.2061H9.35352ZM12.5566 8.4541V15.5H14.0312V13.3418L14.6904 12.5264L16.707 15.5H18.4697L15.7646 11.5645L18.2891 8.4541H16.6484L14.0654 11.6768H14.0312V8.4541H12.5566Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon4k;
